import src from "IMAGE";
export default { src, width: 55, height: 39, blurWidth: 0, blurHeight: 0};
